var OCS = OCS || {};
OCS.Classes = OCS.Classes || {};
OCS.Classes.WorkerDataRequest = new Class({
    Implements: [Options, Events],
    class_type: "DataRequest",
    class_name: "WorkerDataRequest",
    bound_methods: {},
    timeout: null,
    options: {
        timer: 10000,
        worker_id: null,
        path: null,
        msg: {}
    },
    initialize: function (op) {
        this.setOptions(op);
        /* istanbul ignore if */
        if(op && op.msg) {
            // Array buffers do not survive setOptions, so doing it manually.
            this.options.msg = op.msg;
        }
        if(op && op.msg_queue) {
            // Array buffers do not survive setOptions, so doing it manually.
            this.options.msg_queue = op.msg_queue;
        }
        this.bound_methods.on_worker_available = this.on_worker_available.bind(this);
        this.bound_methods.on_timeout = this.on_timeout.bind(this);
        OCS.Functions.get_worker_manager().addEvent('worker_available', this.bound_methods.on_worker_available);
        
        // Fire this off regardless once the timer goes off, make sure we are not forgotten
        this.queue();
    },
    queue: function() {
       this.timeout = setTimeout(this.bound_methods.on_timeout, this.options.timer); 
    },
    on_timeout: function() {
        if(this.timeout) {
            clearTimeout(this.timeout);
            this.timeout = null;
        }
        // check if a worker is available
        var wm = OCS.Functions.get_worker_manager();
        if(wm.has_worker_available(this.options)) {
            // if worker is available pass on the information and destroy this request
            this.on_worker_available();
        } else {
             // if not queue again
             this.queue();
        }
    },
    on_worker_available: function() {
        if(this.timeout) {
            clearTimeout(this.timeout);
            this.timeout = null;
        }
        var wm = OCS.Functions.get_worker_manager();
        if(wm.has_worker_available(this.options) && wm.make_request(this.options)) {
            this.destroy();
        } else {
            this.queue();
        }
        
    },
    destroy: function() {
        if(this.timeout) {
            clearTimeout(this.timeout);
            this.timeout = null;
        }
        OCS.Functions.get_worker_manager().removeEvent('worker_available', this.bound_methods.on_worker_available);
        this.fireEvent('request_destroyed', this);
        this.removeEvents();
        this.$events = {};
        this.bound_methods = {};
        this.initialize = function() {};
        delete this.queue;
        delete this.on_worker_available;
        delete this.on_timeout;
        this.destroy = function() {};
    }
}); 